Vue.component('CronIndexComponent', require('./components/CronIndexComponent').default);
Vue.component('CronGetComponent', require('./components/CronFormComponent').default);
Vue.component('RadioGroup', require('./components/partials/RadioGroup').default);
